<template>
  <header class="app-header navbar">
    <button
      class="navbar-toggler mobile-sidebar-toggler d-lg-none"
      type="button"
      @click="mobileSidebarToggle"
    >
      &#9776;
    </button>
    <b-link
      class="navbar-brand"
      to="/"
    >
      {{ $config_appName }}<br>
      <small>Admin panel</small>
    </b-link>
    <button
      class="navbar-toggler sidebar-toggler d-md-down-none"
      type="button"
      @click="sidebarMinimize"
    >
      &#9776;
    </button>
    <div>
      <ui-breadcrumbs :list="breadcrumbs()" />
    </div>
    <b-nav
      class="ml-auto"
      style="margin-right: 10px;"
    >
      <b-navbar-nav>
        <b-nav-item-dropdown right>
          <template slot="button-content">
            <img
              :src="'https://www.gravatar.com/avatar/' + gravatarHash"
              class="img-avatar"
            >
            <span class="d-md-down-none">{{ username }}</span>
          </template>
          <b-dropdown-item @click="userLogout()">
            <i class="fa fa-lock" /> {{ $t('Logout') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-nav>
  </header>
</template>
<script>
import MD5 from 'blueimp-md5';
import SidebarStateStorage from '../storage/SidebarStateStorage';

export default {
  name: 'AppHeader',
  computed: {
    gravatarHash() {
      if (this.user() !== null) {
        return MD5(this.user().email);
      }
      return '';
    },
  },
  watch: {
    $route() {
      this.updateTitle();
    },
  },
  mounted() {
    this.updateTitle();
  },
  methods: {
    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize(e) {
      e.preventDefault();
      const result = document.getElementById('app').classList.toggle('sidebar-minimized');
      SidebarStateStorage.set(!result);
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    breadcrumbs() {
      const breadcrumbs = [];
      // eslint-disable-next-line
      for (const key in this.$route.matched) {
        const item = this.$route.matched[key];
        if ((item.meta !== undefined && item.meta.breadcrumbs !== undefined)) {
          let title = typeof item.meta.breadcrumbs === 'function' ? item.meta.breadcrumbs() : item.meta.breadcrumbs;
          if (!title.match(/^\d+$/)) {
            title = this.$t(`Breadcrumbs_${title}`);
          }
          breadcrumbs.push({
            title,
            name: typeof item.meta.breadcrumbsAlias !== 'undefined' ? item.meta.breadcrumbsAlias : item.name,
          });
        }
      }
      return breadcrumbs;
    },
    updateTitle() {
      document.title = this.breadcrumbs().map(e => e.title).reverse().join(' / ');
    },
  },
};
</script>
